import { withChartLayout } from 'components/common';
import ClinicalInstituteScale from 'components/features/chart/special-charts/clinical-institute/ClinicalInstituteScale';

const ClinicalInstituteScalePage = withChartLayout('Clinical Institute Withdrawal Assessment of Alcohol Scale (CIWA-Ar)')(ClinicalInstituteScale);
export default ClinicalInstituteScalePage;
